module.exports = __webpack_public_path__ + "fonts/boxicons.b8fb7c66.woff";